
export enum RotasEnum {
    HOME = '/',
    AUTH = '/auth',
    PAINEL = '/painel',
    LOGIN = '/auth/login',
    PRODUTOS = '/painel/produtos',
    PRODUTOS_ADD = '/painel/produtos/add',
    PRODUTOS_EDIT = '/painel/produtos/edit/:id',
    PRODUTOS_METRICAS = '/painel/produtos/metricas/:id',
    CLASSIFICACOES = '/painel/classificacoes',
    TIPOS_DE_CULTURA = '/painel/tipos-de-cultura',
    NUTRIENTES = '/painel/nutrientes',
    NOT_FOUND = '/404',
    SITE_PRODUTO = '/produto/:id',
    USUARIOS = '/painel/usuarios',
    USUARIOS_ADD = '/painel/usuarios/add',
    USUARIOS_EDIT = '/painel/usuarios/edit/:id',
    TIPOS_DE_DOCUMENTOS = '/painel/tipos-de-documentos'
}